/**
 * Centralized configuration for the ErgShoot web application.
 * All environment variables and constants should be exported from here.
 */

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787/api';

export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

export const IS_DEVELOPMENT = import.meta.env.DEV;
export const IS_PRODUCTION = import.meta.env.PROD;
